import React from 'react';
import { Layout, Typography } from 'antd';
import { appInsights } from "../../core/services/insight.service";
 
const { Content } = Layout;
const { Title } = Typography;
 
const Help: React.FC = () => {
  return (
<Layout>
<Content>
<Title level={2}
        style={{
            color: '#009dd9',
            margin:0,
            textAlign:'left'
          }}
>Get Help Using the Accounts Request Application</Title>
</Content>
</Layout>
  );
};
 
export default Help;